/* <wg-wa-review>: opens the full-size screenshot lightbox for a WhatsApp review card.
   Markup: sections/wg-whatsapp-testimonials.liquid. */
(() => {
  if (customElements.get('wg-wa-review')) return;

  class WGWaReview extends HTMLElement {
    connectedCallback() {
      this.opener = this.querySelector('[data-wg-wa-open]');
      this.dialog = this.querySelector('dialog');
      if (!this.opener || !this.dialog) return;

      this.opener.addEventListener('click', () => this.open());
      this.querySelector('[data-wg-wa-close]')?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        // Clicks on the backdrop land on the dialog itself; the inner wrapper swallows the rest
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('wg-wa-lock');
        this.opener.focus({ preventScroll: true });
      });
    }

    open() {
      if (this.dialog.open) return;
      document.documentElement.classList.add('wg-wa-lock');
      this.dialog.showModal();
      this.querySelector('[data-wg-wa-close]')?.focus();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }
  }

  customElements.define('wg-wa-review', WGWaReview);
})();
